import {get as _get} from "lodash";
import store from '../store';
const methods = {
    NEST: {
        login: 'LoginNest',
        logout: 'LogoutNest',
    },
    DEALER_ID: {
        login: 'LoginDefault',
        logout: 'LogoutDefault',
    }
}

function getAuthMethod()
{
    let tokenPayload = store.getters['Auth/tokenPayload'];
    let type;

    if (tokenPayload) {
        type = tokenPayload.auth_method;
    } else {
        type = _get(store.state, 'context.app.authenticationMethod');
    }

    if (typeof type === 'string' && methods.hasOwnProperty(type)) {
        return methods[type];
    }

    return methods.DEALER_ID;
}

export function getLoginMethod()
{
    return getAuthMethod().login;
}

export function getLogoutMethod()
{
    return getAuthMethod().logout;
}